import { CANDLE_MIN_WIDTH } from "features/chart";
import type { ZoomRange } from "features/chart";
import type { ChartLayout, ChartPriceRange } from "./types";

export function yToPrice(y: number, layout: ChartLayout, range: ChartPriceRange): number {
  const chartHeight = layout.height - layout.top - layout.bottom;
  return range.max - ((y - layout.top) * (range.max - range.min)) / chartHeight;
}

export function priceToY(price: number, layout: ChartLayout, range: ChartPriceRange): number {
  const chartHeight = layout.height - layout.top - layout.bottom;
  return layout.top + ((range.max - price) / (range.max - range.min)) * chartHeight;
}

export function getCandleWidth(layout: ChartLayout, zoom: ZoomRange): number {
  const chartWidth = layout.width - layout.left - layout.right;
  const visibleCount = Math.floor(zoom.end) - Math.floor(zoom.start) + 1;
  return Math.max(CANDLE_MIN_WIDTH, chartWidth / visibleCount);
}

export function timestampToX(
  timestamp: number,
  layout: ChartLayout,
  zoom: ZoomRange,
  firstVisibleMs: number,
  timeframeMs: number,
): number {
  const candleWidth = getCandleWidth(layout, zoom);
  return layout.left + ((timestamp - firstVisibleMs) / timeframeMs + 0.5) * candleWidth;
}

export function xToTimestamp(
  x: number,
  layout: ChartLayout,
  zoom: ZoomRange,
  firstVisibleMs: number,
  timeframeMs: number,
): number {
  const candleWidth = getCandleWidth(layout, zoom);
  const indexFloat = (x - layout.left) / candleWidth - 0.5;
  return firstVisibleMs + indexFloat * timeframeMs;
}
